export async function GetJavadex(userId: string) {
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/javadex/${userId}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (response.status !== 200) {
            return [];
        }

        const data = await response.json();
        return data;
    } catch (e) {
        console.error("GetJavadex error:", e);
        return [];
    }
}
